import React from "react";
import "../css/privacy.scss";

function FAQs() {
  return <main className="privacy-page"><div className="content-container">
    <h1 className="page-title">frequently asked questions</h1>
    <h2 className="section-main-heading">PEARLS &amp; MATERIALS</h2>
    <h3 className="section-sub-heading">ARE THE PEARLS IDENTICAL?</h3><p>No. Freshwater pearls naturally vary slightly in shape, surface and colour. Product photographs show the overall style rather than one guaranteed pearl.</p>
    <h3 className="section-sub-heading">HOW SHOULD I CARE FOR MY JEWELLERY?</h3><p>Keep pieces dry, avoid perfume and household chemicals, wipe gently after wear, and store each piece separately in a soft pouch.</p>
    <h2 className="section-main-heading">ORDERS</h2>
    <h3 className="section-sub-heading">WHEN WILL MY ORDER SHIP?</h3><p>Orders are normally prepared within 3–5 business days. Delivery timing depends on destination and carrier conditions.</p>
    <h3 className="section-sub-heading">CAN I CHANGE AN ORDER?</h3><p>Email service@pmistpearl.work promptly. We will help if fulfilment has not begun, but changes cannot be guaranteed after dispatch.</p>
    <h3 className="section-sub-heading">HOW DO RETURNS WORK?</h3><p>Contact us before returning an item. Unauthorised returns and worn jewellery cannot be accepted for hygiene reasons.</p>
  </div></main>;
}
export default FAQs;
